// src/components/MainRouter.js
import React from 'react';
import { Routes, Route } from 'react-router-dom';
import LoginPage from '../pages/LoginPage';
import QueuePage from '../pages/QueuePage';
import FeedPage from '../pages/FeedPage';
import ArtistPage from '../pages/ArtistPage';
import ArtistsPage from '../pages/ArtistsPage';
import PlatformPage from '../pages/PlatformPage';
import SongPage from '../pages/SongPage';
import SignupPage from '../pages/SignupPage';
import ProfilePage from '../pages/ProfilePage';
import SearchPage from '../pages/SearchPage';
import OnelinerHistoryPage from '../pages/OnelinerHistoryPage';
import TagsPage from '../pages/TagsPage';
import AddSong from '../pages/AddSong';
import UploadSong from '../pages/UploadSong';

export default function MainRouter() {
  return (
    <Routes>
      <Route path="/" element={<QueuePage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/signup" element={<SignupPage />} />
      <Route path="/profile" element={<ProfilePage />} />
      <Route path="/feed" element={<FeedPage />} />
      <Route path="/artist/:id" element={<ArtistPage />} />
      <Route path="/artists" element={<ArtistsPage />} />
      <Route path="/artists/:letter" element={<ArtistsPage />} />
      <Route path="/search" element={<SearchPage />} />
      <Route path="/onelinerhistory" element={<OnelinerHistoryPage />} />
      <Route path="/song/:id" element={<SongPage />} />
      <Route path="/platform" element={<PlatformPage />} />
      <Route path="/platform/:platform" element={<PlatformPage />} />
      <Route path="/tags" element={<TagsPage />} />
      <Route path="/tags/:tag" element={<TagsPage />} />
      <Route path="/addsong" element={<AddSong />} />
      <Route path="/uploadsong/:songid" element={<UploadSong />} />
    </Routes>
  );
}
